import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

import ErrorBoundary from './components/ErrorBoundary.tsx'

import { AuthProvider } from './contexts/AuthContext'
import { PresentationModeProvider } from './contexts/PresentationModeContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <PresentationModeProvider>
          <App />
        </PresentationModeProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
)
